<template>
  <div class="bg-white">
    <div class="row">
      <div class="col-lg-12 col-xl-12">
        <vue-custom-scrollbar
          :style="`height: ${scrollHeight.content}px; position: relative; `"
        >
          <div class="row row-sm mg-b-25">
            <div
              v-for="(invoice, i) in list.filter((x) =>
                $route.params.status == 0
                  ? x.isTender != true
                  : $route.params.status == 1
                  ? x.isTender == true
                  : true
              )"
              :key="'event' + i"
              class="col-md-6 mg-t-20 mg-md-t-0"
            >
              <template v-if="!invoice.isTender">
                <router-link
                  :to="`/lms/paymentDetail/${invoice.id}`"
                  class="link-01"
                >
                  <invoice-item :invoice="invoice"></invoice-item>
                </router-link>
              </template>
              <template v-else>
                <div @click="showInvoice(invoice)">
                  <invoice-item
                    :hasEbarimt="hasEbarimt"
                    :invoice="invoice"
                  ></invoice-item>
                </div>
              </template>
            </div>
          </div>
        </vue-custom-scrollbar>
      </div>
    </div>
     <b-modal
      v-model="ebarimtObj.modal"
      hide-footer
      title="И-Баримт"
      centered
      body-class="pd-0"
      size="md"
      scrollable
    >
      <div class="modal-body" ref="mdlEbarimt" style="font-size: 0.85em">
        <!-- {{modalEbarimt.id}} -->
        <template v-if="ebarimtObj.mode == 1">
          <Form label-width="160">
            <FormItem label="И-баримт авах хэлбэр">
              <Select v-model="ebarimtObj.type" plaeHolder="Сонгоно уу">
                <Option value="1" label="Байгууллага">Байгууллага</Option>
                <Option value="0" label="Хувь хүн">Хувь хүн</Option>
              </Select>
            </FormItem>
            <FormItem label="Байгууллагын регистр" v-if="ebarimtObj.type == 1">
              <Input v-model="ebarimtObj.regNo" placeholder="Бичнэ үү.." />
            </FormItem>
          </Form>
          <div class="pd-sm">
            <button
              @click="generateEbarimt()"
              class="btn btn-block btn-primary"
            >
              Баримт авах
            </button>
          </div>
        </template>
        <template v-else-if="ebarimtObj.mode == 2">
          <div class="pd-md">
            <div class="row d-flex mb-10">
              <div class="col col-12 text-center m-b-md">
                <h5 >
                  {{companyName}}
                  <!-- Монголын мэргэшсэн нягтлан бодогчдын институт -->
                </h5>
              </div>
              <div class="col col-4">Огноо</div>
              <div class="col col-8 text-right">
                {{ ebarimtObj.ebarimt.date | moment("YYYY.MM.DD HH:mm") }}
              </div>
              <div class="col col-4">ТТД</div>
              <div class="col col-8 text-right">
                {{ ebarimtObj.ebarimt.billId }}
              </div>
            </div>
            <table
              class="tbl-stock"
              style="width: 100%"
              cellspacing="0"
              cellpadding="0"
            >
              <thead>
                <th style="width: 30px">Д/д</th>
                <th>Бичилт</th>
                <th style="width: 80px;">Нэгж үнэ</th>
                <th style="width: 30px">Хэмжээ</th>
                <th style="width: 80px">Нийт үнэ</th>
              </thead>
              <tbody>
                <tr
                  v-for="(s, i) in ebarimtObj.ebarimt.stocks"
                  :key="i"
                  style="border-top: 1px solid #000"
                >
                  <td style="text-align: center">{{ i + 1 }}</td>
                  <td style="text-align: left">{{ s.name }}</td>
                  <td>{{ s.unitPrice }}</td>
                  <td>{{ s.qty }}</td>
                  <td>{{ s.totalAmount }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="row d-flex">
            <div class="col col-12 text-center">
              <img :src="`data:image/png;base64, ${ebarimtObj.base64}`" />
              <!-- <qrcode-vue id="qr_canvas" :value="ebarimtObj.ebarimt.qrData" :size="qrOption.size" level="L" ></qrcode-vue> -->
              <!-- {{ebarimtObj.ebarimt}} -->
            </div>
            <div class="col col-5 text-right p-r-xs">Дүн:</div>
            <div class="col col-7" style="font-weight: 700">
              {{ ebarimtObj.ebarimt.amount }}
            </div>
            <div class="col col-5 text-right p-r-xs">Сугалаа:</div>
            <div class="col col-7" style="font-weight: 700">
              {{ ebarimtObj.ebarimt.lottery }}
            </div>

            <div class="text-right notprint wd-100p">
              <button
                @click="downloadEbarimt()"
                class="btn btn-sm btn-outline-primary notprint mg-r-20"
              >
                ТАТАХ
              </button>
            </div>
          </div>
        </template>
        <div v-else-if="ebarimtObj.mode == 3" class="p-md">
          <div
            class="ivu-alert ivu-alert-info ivu-alert-with-icon ivu-alert-with-desc"
          >
            <span class="ivu-alert-icon">
              <i class="ivu-icon ivu-icon-ios-information-circle-outline"></i>
            </span>
            <span class="ivu-alert-message">Санамж</span>
            <span class="ivu-alert-desc"
              >Та байгууллага дээр Е баримт авах бол info@monicpa.mn хаягаар
              төлбөр төлсөн баримт байгууллагын регистрийн дугаараа холбоо барих
              дугаартай явуулна уу! Лавлах 70007888</span
            >
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
import { mapActions } from "vuex";

import {
  coreBoxInTaskList,
  getListFields,
  getSearchFields,
} from "@/api/taskCore";
import {
  getInheritedTask,
  postInheritedTask,
  taskInheritedDetail,
} from "@/api/task";

import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";
import vueCustomScrollbar from "vue-custom-scrollbar";

import { hasOneOf } from "@/libs/tools";
import { request } from "@/api/all";
import { Form, FormItem, Input, Select, Option } from "element-ui";
import "element-ui/lib/theme-chalk/index.css";


export default {
  components: {
     Form,
    FormItem,
    Input,
    Select,
    Option,
    vueCustomScrollbar,
    invoiceItem: () => ({
      component: import("@/views/modules/lms/payment/list/paymentItem.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
  },
  props: {
    parentTask: {
      type: Object,
      default: () => {},
    },
    box: {
      type: Object,
      default: () => {},
    },
    prms: {
      type: Object,
      default: () => {},
    },
    obj: {
      type: Object,
      default: () => {},
    },
    activeBox: {
      type: Object,
      default: () => {},
    },
    detailSettingProp: {
      type: Object,
      default: () => null,
    },
  },
  data() {
    return {
      list: [],
      scrollHeight: {
        contentToolbarHeight: 49,
        nav: 0,
        content: 0,
        right: 0,
      },
      detailSetting: {
        boxSetting: {
          hideToolbar: false,
          hideAddButton: false,
          hideEmptyTemplate: false,
          listSetting: {
            height: 300,
            disableDetail: false,
          },
        },
      },

      fetched: false,
      tasks: [],
      allCount: 0,
      tasksCount: 0,
      task: {},
      fields: [],

      nowDate: "",
      projectStat: {},
      mediaFinder: {
        show: false,
        id: 0,
        key: 0,
      },
      linkAttaching: {
        taskId: 0,
        field: "",
      },
      processing: false,
      busy: false,
      processingObj: 0,
      processingMode: 0,
      taskCur: {
        id: 0,
      },
      pager: {
        perPage: 20,
        current: 1,
      },
      boxFilter: {
        searches: [],
        modal: false,
        searchesKey: 0,
      },
      coreSearchModel: {},
      hasEbarimt: false,
      ebarimtObj: {
        modal: false,
        key: 0,
        id: 0,
        type: null,
        regNo: "",
        mode: 0,
        ebarimt: {},
        base64: null
      },
      qrOption: {
        value: "",
        size: 150
      },
      companyName:""
    };
  },
  mounted() {
    require("@/assets/css/dynamic.detail.css");
    // this.initFields();
    // if (this.detailSettingProp != null) {
    //   let tmp = this.detailSetting;
    //   this.detailSetting = this.detailSettingProp;
    //   if (this.detailSettingProp.boxSetting == undefined) {
    //     this.detailSetting.boxSetting = tmp.boxSetting;
    //   }
    // }
    let _ebarimt = this.$store.state.app.groupSettings.filter(
      (x) => x.key == "paymentEbarimt"
    );
    if (
      _ebarimt.length > 0 &&
      _ebarimt[0].value != undefined &&
      _ebarimt[0].value == "1"
    ) {
      this.hasEbarimt = true;
    }

    let _companyName = this.$store.state.app.groupSettings.filter(
      x => x.key == "companyName"
    );
    if (
      _companyName.length > 0 
    ) {
      this.companyName = _companyName[0].value;
    }

    this.init();

    window.addEventListener("resize", this.getWindowHeight);
    this.getWindowHeight();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.getWindowHeight);
  },
  methods: {
    ...mapActions(["handleUserInfoModal"]),
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;
      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    getWindowHeight() {
      let contentSub = 120;
      let navSub = 120;
      let rightSub = 120;
      if (screen.width <= 1024) {
        contentSub = 85;
        navSub = 85;
        rightSub = 85;
      }

      contentSub += this.scrollHeight.contentToolbarHeight;
      rightSub += this.scrollHeight.contentToolbarHeight;

      this.scrollHeight.content = window.innerHeight - contentSub;
      this.scrollHeight.nav = window.innerHeight - navSub;
      this.scrollHeight.right = window.innerHeight - rightSub;

      if (
        this.detailSetting.boxSetting.autoHeight != undefined &&
        this.detailSetting.boxSetting.autoHeight
      ) {
        this.detailSetting.boxSetting.listSetting.height = "auto";
      } else {
        //console.log('iishee orvuu');
        let minusHeight = this.detailSetting.boxSetting.hideToolbar ? 165 : 220;
        minusHeight = minusHeight - (this.detailSetting.hideToolbar ? 60 : 0);
        this.detailSetting.boxSetting.listSetting.height =
          window.innerHeight - minusHeight + "px";
        //console.log('iishee orvuu', (window.innerHeight - minusHeight)+'px');
      }
    },
    reInit(e) {
      this.init(e);
    },
    showDetail(t) {
      if (!this.detailSetting.boxSetting.listSetting.disableDetail)
        this.$emit("on-detail", t, 80);
    },
    taskDeleted(id) {
      //this.tasks
      let i = this.tasks.map((st) => st.id).indexOf(id);
      this.tasks.splice(i, 1);
      this.tasksCount = this.tasksCount - 1;
    },
    init(force) {
      this.toggleBodyClass("addClass", "dynamic-locker");
      //console.log('core box init fired');
      let self = this;
      this.tasks = [];
      if (force) {
        this.pager.current = 1;
      }
      request({
        api: { method: "POST", url: "Payment/GetAuditCompanyInvoices" },
        data: {
          id: this.parentTask.id,
          //skip: (this.pager.current - 1) * this.pager.perPage,
          //size: this.pager.perPage,
          //model: this.coreSearchModel
        },
        store: this.$store,
      }).then((res) => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        this.list = res.data.tasks; //console.log('res.data.tasks.length', res);

        this.tasksCount = res.data.tasksCount;
        this.allCount = res.data.allCount;
        this.fetched = true;
        this.$emit("box-loaded", res.data);
      });
    },
    taskDetail(id) {
      taskInheritedDetail({
        params: { id: id, sourceFlag: 1 },
        store: this.$store,
      }).then((res) => {
        if (res != false) {
          this.task = res.data.task;
        }
      });
    },
    updateField(e) {
      getInheritedTask({ params: { id: e.taskId }, store: this.$store }).then(
        (res) => {
          var _model = res.data.task;
          if (e.mode == 0) {
            _model[e.field.field] = !(e.value === true);
            this.updateTaskInherited(_model, 0);
          } else if (e.mode == 2) {
            _model[e.field.field] = e.value;
            this.processingObj = _model;
            this.busy = true;
          } else if (e.mode == 22) {
            _model[e.field.field] = e.value;
            this.updateTaskInherited(_model, 22);
          } else if (e.mode == 888) {
            _model[e.field] = e.value;
            this.updateTaskInherited(_model, e.mode);
          } else if (e.mode == 1) {
            //_model[e.field] = e.value;
            //this.updateTaskInherited(_model, e.mode);
            this.init();
          }
        }
      );
    },
    updateTaskInherited(obj, mode) {
      let self = this;
      if (!this.hasPermission(["admin"])) {
        if (mode == 2 || mode == 22) {
          this.processing = true;
          if (
            this.parentTask.user != null &&
            this.parentTask.user.userId == this.$store.state.user.userId
          ) {
            if (!(this.parentTask.im != null && this.parentTask.im.pinIs)) {
              setTimeout(() => {
                self.$bvToast.toast("Үйлдлийг гүйцэтгэх боломжгүй", {
                  title: "Мэдэгдэл",
                  autoHideDelay: 5000,
                  appendToast: false,
                  variant: "warning",
                  toaster: "b-toaster-bottom-left",
                });
                self.processing = false;
                self.busy = false;
              }, 500);

              return;
            }
          } else {
            setTimeout(() => {
              self.$bvToast.toast("Үйлдлийг гүйцэтгэх боломжгүй", {
                title: "Мэдэгдэл",
                autoHideDelay: 5000,
                appendToast: false,
                variant: "warning",
                toaster: "b-toaster-bottom-left",
              });
              self.processing = false;
              self.busy = false;
            }, 500);

            return;
          }
        }
      }

      postInheritedTask({
        data: { model: obj },
        store: this.$store,
      }).then((res) => {
        if (res != false) {
          if (mode == 888) {
            this.mediaFinder.show = false;
            this.init();
          } else if (mode == 2) {
            this.processing = false;
            this.busy = false;
            this.init();
          } else if (mode == 22) {
            this.init();
          } else if (mode == 0) {
            this.init();
          } else if (mode == 1) {
            this.init();
          }
        }
      });
    },
    hasPermission(perrArr) {
      return hasOneOf(perrArr, this.$store.state.user.access);
    },
    showFinder(e) {
      if (!this.hasPermission(["admin"])) {
        if (
          this.parentTask.user != null &&
          this.parentTask.user.userId == this.$store.state.user.userId
        ) {
          if (!(this.parentTask.im != null && this.parentTask.im.pinIs)) {
            this.$bvToast.toast("Үйлдлийг гүйцэтгэх боломжгүй", {
              title: "Мэдэгдэл",
              autoHideDelay: 5000,
              appendToast: false,
              variant: "warning",
              toaster: "b-toaster-bottom-left",
            });
            return;
          }
        } else {
          this.$bvToast.toast("Үйлдлийг гүйцэтгэх боломжгүй", {
            title: "Мэдэгдэл",
            autoHideDelay: 5000,
            appendToast: false,
            variant: "warning",
            toaster: "b-toaster-bottom-left",
          });
          return;
        }
      }
      this.linkAttaching.taskId = e.taskId;
      this.linkAttaching.field = e.field;
      this.mediaFinder.show = true;
    },
    fileAttached(e) {
      this.updateField({
        mode: 888,
        value: e,
        taskId: this.linkAttaching.taskId,
        field: this.linkAttaching.field,
      });
    },
    taskAttached(e) {
      request({
        api: { method: "POST", url: "Box/ConnectTaskToBox" },
        data: { taskId: e.id, boxId: this.box.id },
        store: this.$store,
      }).then((res) => {
        if (res != false) {
          this.init();
        }
      });
    },
    detachTaskFromBox(tid) {
      this.processingObj = tid;
      this.processingMode = -100;
      this.busy = true;
    },
    detachTaskFromBoxAfter() {
      this.processing = true;

      request({
        api: { method: "POST", url: "Box/DisconnectTaskFromBox" },
        data: { taskId: this.processingObj, boxId: this.box.id },
        store: this.$store,
      }).then((res) => {
        this.processingMode = 0;
        this.processing = false;
        this.busy = false;

        if (res != false) {
          this.init();
        }
      });
    },
    boxRowSelect(t) {
      this.tasks = this.tasks.map(function (e) {
        e.selcd = e.id == t.id;
        return e;
      });
    },
    pageChanged(e) {
      this.pager.current = e;
      this.init();
    },
    showBoxFilter() {
      getSearchFields({
        params: { objectTypeId: this.box.ot },
        store: this.$store,
      }).then((res) => {
        if (res != false) {
          this.boxFilter.searches = res.data.fields.map((e) =>
            Object.assign(e, { val: "" })
          );
          this.boxFilter.modal = true;
        }
      });
    },
    filterCoreBox(reset) {
      if (reset) {
        this.$refs.srchFields.reset();
      } else {
        this.$refs.srchFields.filter();
      }
    },
    exportBoxHandle() {
      this.$refs.srchFields.export();
    },
    exportBox(e) {
      //console.log('e', e);
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "POST", url: "taskCore/coreBoxInTaskExport" },
        data: { id: this.box.id, model: e, skip: 0, size: 99999 },
        store: this.$store,
      }).then((res) => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        //console.log(res);
        if (res != false) {
          this.boxFilter.modal = false;
          this.$emit("on-attach", res.data.file.id);
        }
      });
    },
    onSearchFired(e) {
      this.coreSearchModel = e;
      //console.log('this.coreSearchModel', this.coreSearchModel);
      this.init(true);
    },
    showInvoice(e) {
      if (e.isTender) {
        //let hasEbarimt= getConfigValueByKey( this.$store.state.app.groupSettings, "paymentEbarimt");
        if (this.hasEbarimt != undefined) {
          if (this.hasEbarimt == 1) {
            this.showEbarimtQR(e.id, 0);
          } else {
            //this.$Notice.success({ desc: "Төлбөр төлөгдсөн байна." });
          }
        } else {
          //this.$Notice.success({ desc: "Төлбөр төлөгдсөн байна." });
        }
      }
      //else{
      //this.showPayment(e.id);
      //}
    },
    showEbarimtQR(id, mode) {
      //checkEBarimt({id: id})
      //EBarimt/CheckEBarimt
      request({
        api: { method: "POST", url: "EBarimt/CheckEBarimt" },
        store: this.$store,
        data: { id: id }
      }).then(res => {
        if (res != false) {
          if (res.data.result == 0) {
            this.ebarimtObj.mode = 1;
            this.ebarimtObj.id = id;
            this.ebarimtObj.modal = true;
            this.ebarimtObj.key++;
          } else if (res.data.result == 1) {
            //generate({qr: res.data.ebarimt.qrData})
            request({
              api: { method: "POST", url: "QR/Generate" },
              store: this.$store,
              data: { qr: res.data.ebarimt.qrData }
            }).then(res => {
              if (res != false) {
                this.ebarimtObj.base64 = res.data.base64;
              }
            });
            this.ebarimtObj.mode = 2;
            this.ebarimtObj.ebarimt = res.data.ebarimt;
            this.ebarimtObj.modal = true;
            this.ebarimtObj.key++;
          }
        }
      });
    },
    downloadEbarimt() {
      var _content = this.$refs.mdlEbarimt.innerHTML;
      var mywindow = window.open("", "Print", "height=600,width=400");

      mywindow.document.write("<html><head><title>Print</title>");
      mywindow.document.write("</head><body >");
      mywindow.document.write(_content);
      mywindow.document.write("</body></html>");

      mywindow.document.close();
      mywindow.focus();
      mywindow.print();
      mywindow.close();
    },
    generateEbarimt() {
      let errs = [];
      if (!(this.ebarimtObj.type == "1" || this.ebarimtObj.type == "0")) {
        errs.push("И-баримт авах хэлбэр сонгоно уу!");
      }

      if (this.ebarimtObj.type == "1" && this.ebarimtObj.regNo.length == 0) {
        errs.push("Байгууллагын регистер бичнэ үү!");
      }

      if (errs.length > 0) {
        this.$Notice.warning({ title: "Мэдэгдэл", desc: errs[0] });
      } else {
        //$("#app").addClass("dynamic-locker");
        // postEBarimtOption({
        //   invoiceId: this.ebarimtObj.id,
        //   type: parseInt(this.ebarimtObj.type, 10),
        //   regNo: parseInt(this.ebarimtObj.regNo, 10)
        // })

        request({
          api: { method: "POST", url: "EBarimt/PostEBarimtOption" },
          store: this.$store,
          data: {
            invoiceId: this.ebarimtObj.id,
            type: parseInt(this.ebarimtObj.type, 10),
            regNo: parseInt(this.ebarimtObj.regNo, 10)
          }
        }).then(res => {
          //$("#app").removeClass("dynamic-locker");
          if (res != false) {
            // if (this.ebarimtObj.type == "1") {
            //   this.ebarimtObj.mode = 3;
            //   this.ebarimtObj.modal = true;
            //   this.ebarimtObj.key++;
            // } else {

              //$("#app").addClass("dynamic-locker");
              //createBill({ id: this.ebarimtObj.id })
              request({
                api: { method: "POST", url: "EBarimt/CreateBill" },
                store: this.$store,
                data: {
                  id: this.ebarimtObj.id
                }
              }).then(res => {
                //$("#app").removeClass("dynamic-locker");
                if (res != false) {
                  request({
                    api: { method: "POST", url: "QR/Generate" },
                    store: this.$store,
                    data: { qr: res.data.ebarimt.qrData }
                  }).then(res => {
                    if (res != false) {
                      this.ebarimtObj.base64 = res.data.base64;
                    }
                  });
                  this.ebarimtObj.mode = 2;
                  this.ebarimtObj.ebarimt = res.data.ebarimt;
                  this.ebarimtObj.modal = true;
                  this.ebarimtObj.key++;
                }
              });
            //}
          }
        });
      }
    },
  },
};
</script>
<style>
@media print {
  .notprint {
    display: none !important;
  }
}
.tbl-stock thead tr th {
  text-align: left;
}
.tbl-stock tbody tr td {
  border-top: 2px solid #000;
  text-align: right;
  padding: 5px 0;
  line-height: 1.2;
}
.gn-fields .ivu-card-body .ivu-form .ivu-form-item {
  margin-bottom: 10px !important;
}
/* .ivu-form-item{
  margin-bottom: 10px !important;
} */
</style>